/**
 * Aceleres: duração de mídia no formato do WhatsApp (m:ss).
 *
 * Saiu do chip de áudio (components-next/message/chips/Audio.vue) quando a
 * citação de uma resposta também passou a mostrar a duração — a mesma regra
 * escrita duas vezes divergiria na primeira mudança.
 *
 * Sem duração conhecida devolve "0:00", que é o que o WhatsApp mostra até o
 * arquivo ser lido.
 */
export const formatMediaDuration = seconds => {
  if (!seconds || !Number.isFinite(seconds)) return '0:00';

  const minutes = Math.floor(seconds / 60);
  const rest = Math.floor(seconds % 60);

  return `${minutes}:${String(rest).padStart(2, '0')}`;
};
